import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import {array, element, func, number, object, string} from 'prop-types';
import React, {Fragment, cloneElement, useCallback, useState} from 'react';

const InputItem = ({
  label,
  index,
  remove,
  component: Component,
  value,
  offset,
}) => {
  return (
    <FormGroup sx={{paddingBottom: 2}}>
      <Paper variant="outlined" sx={{padding: 2}}>
        <FormLabel
          sx={{display: 'flex', alignItems: 'center', marginBottom: 1}}
        >
          {label} {index + 1 - offset}{' '}
          {remove && (
            <IconButton size="small" sx={{marginLeft: 1}} onClick={remove}>
              <RemoveCircleOutlineIcon fontSize="inherit" />
            </IconButton>
          )}
        </FormLabel>
        {cloneElement(Component, {
          value,
          index,
        })}
      </Paper>
    </FormGroup>
  );
};

InputItem.propTypes = {
  label: string.isRequired,
  index: number.isRequired,
  remove: func,
  component: element.isRequired,
  value: object,
  offset: number,
};

function InputList({list, component, label, offset = 0}) {
  const [count, setCount] = useState(list?.length || 1);
  const add = useCallback(() => setCount(count + 1), [count]);

  const remove = useCallback(() => {
    if (count > 1) {
      setCount(count - 1);
    }
  }, [count]);

  const items = new Array(count);

  for (let i = 0; i < count; i++) {
    const includeRemove = i > 0 && i === count - 1;

    items[i] = (
      <InputItem
        key={i}
        index={i + offset}
        value={list?.[i]}
        remove={includeRemove ? remove : null}
        label={label}
        component={component}
        offset={offset}
      />
    );
  }

  items.push(
    <Button key="add-button" onClick={add}>
      Add {label}
    </Button>,
  );

  return <Fragment>{items}</Fragment>;
}

InputList.propTypes = {
  list: array,
  component: element.isRequired,
  label: string,
  offset: number,
};

export default InputList;
